const FALLBACK_LOCALE_ID = 1;

const TOKEN_ROUTE_LOCALE = /^\/(?:form|chat)\/[^/]+\/(\d+)\/?$/;

/**
 * The locale a candidate URL names, readable before any data loads: `?locale=`
 * on slug routes, the last segment on `/form|chat/:token/:localeId`. English
 * otherwise, as `getChatConfigValue` falls back.
 */
export function readUrlLocaleId(location: {
  pathname: string;
  search: string;
}): number {
  const fromPath = TOKEN_ROUTE_LOCALE.exec(location.pathname)?.[1];
  const raw = fromPath ?? new URLSearchParams(location.search).get('locale');
  const parsed = raw ? parseInt(raw, 10) : NaN;

  return Number.isInteger(parsed) && parsed > 0 ? parsed : FALLBACK_LOCALE_ID;
}
